/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventNavController', DinghyEventNavController);

    DinghyEventNavController.$inject = ['$stateParams', 'entity'];

    function DinghyEventNavController($stateParams, entity) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.dinghyEvent = entity;
    }
})();
